import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { CommodityGroupsProvider as Provider } from '../../components/context/commodity-groups-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllCommodityGroupsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "CommodityGroups" } }) {
    nodes {
      data
    }
  }
}
`;

export const CommodityGroupsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
